import { getLocaleMeta, normalizeLocale, type SupportedLocale } from '~/utils/localeController'

export type TenantLanguageOption = {
  code: SupportedLocale
  label: string
  emoji: string
}

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null && !Array.isArray(value)
)

const normalizeText = (value: unknown): string => String(value || '').trim()

export const normalizeTenantLanguageOptions = (value: unknown): TenantLanguageOption[] => {
  if (!Array.isArray(value)) return []

  const seen = new Set<string>()
  const options: TenantLanguageOption[] = []

  for (const item of value) {
    if (!isRecord(item)) continue
    const code = normalizeLocale(item.code)
    if (seen.has(code)) continue
    seen.add(code)

    const meta = getLocaleMeta(code)
    const label = normalizeText(item.name) || normalizeText(item.label) || meta.label
    const emoji = normalizeText(item.emoji) || meta.emoji

    options.push({ code, label, emoji })
  }

  return options
}

export const resolveTenantMainLanguage = (
  mainLanguage: unknown,
  targetLanguage: unknown,
  fallbackLanguage: unknown,
): SupportedLocale => {
  const normalizedMain = normalizeText(mainLanguage) ? normalizeLocale(mainLanguage) : null
  const options = normalizeTenantLanguageOptions(targetLanguage)

  if (normalizedMain) return normalizedMain
  if (options[0]?.code) return options[0].code
  return normalizeLocale(fallbackLanguage)
}